module.exports = __webpack_public_path__ + "static/media/vertical-divider.a15a563e.svg";